import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { SearchService } from '../../../shared/search/search.service';
import { Logging } from '../../../logging';

@Component({
  selector: 'app-total-subusers-panel',
  templateUrl: './total-subusers-panel.component.html',
  styleUrls: ['./total-subusers-panel.component.css']
})
export class TotalSubusersPanelComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers : HelpersService,
    private searchService: SearchService) { }

    loading: boolean;
    total_users: number = 0;
    full_access : number = 0;
    limited_access: number =0;

  ngOnInit() {

    this.api.get('/users/'+ this.auth.getUserID() + '/subusers')
    .subscribe(
      res_data => {
        Logging.log(res_data.data.totalElements);
        var self = this;
        this.total_users = res_data.data.totalElements;
        if(this.total_users > 0)
        {
            res_data.data.content.forEach(function(u){

              if(u.profile.profilename == 'Full')
              {
                self.full_access+= 1;
              }
              else{
                self.limited_access+= 1;
              }
            });
        }
      
      }, error_message => {
        this.loading = false;
      }
    );
}

  

 

 
  Helpers(){
    return this.helpers;
  }
}



// WEBPACK FOOTER //
// ./src/app/client/account/total-subusers-panel/total-subusers-panel.component.ts